import React from 'react';
import {CompetenciesByPillarSelect} from './CompetencyByPillarSelect';

export const CompetenciesByPillarWithInfoSelect = () => {
  return <CompetenciesByPillarSelect infoText="Choose a pillar first." />;
};
